(function() {
	window["__patient_portal_global_vars__"] = {
		baseResourceUrl: "/PatientPortal/",
		AuthServerUrl: "{$ENV_FULL_NAME}/AuthenticationServer",
		WebApiUrl: "{$ENV_FULL_NAME}/RISWebServer",
		externalAuthentication: false,
		useBackendExternalAuthentication: true,
		externalLoginPageUrl: "{$ExternalLoginPageUrlWithoutOrigin}",
		loggerDefaults: {
			"appender": "browserConsole",
			"appenderLevel": "5",
			"loggerLevel": "5"
		},
		webForms: {
			patientSearchURL: "Web/forms?form=@FORM_NAME@&theme=dynamic&dataFromParent=true&dataLevel=Patient",
			patientDetailsURL: "Web/forms?form=@FORM_NAME@&theme=dynamic&dataFromParent=true&dataLevel=Patient",
			moreInfoURL: "Web/forms?form=@FORM_NAME@&theme=dynamic&dataFromParent=true&dataLevel=Order",
			kioskManualIdUrl: "Web/forms?form=@FORM_NAME@&theme=dynamic&dataFromParent=true&dataLevel=Patient",
		}
	};
})();
